(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["renovix-foto-superpuesta"] && !Shopify.designMode) return;
  try {
    
/* [V2-STICKY] La sección anterior ya NO se mueve a base de escribirle un "translate" nuevo en cada
   fotograma (en móvil el scroll lo lleva otro hilo y el translate llegaba un fotograma tarde:
   la sección anterior temblaba). Ahora la sujeta el navegador con position:sticky y el JS solo
   escribe cuando se CRUZA un umbral, nunca en cada fotograma:
     none   -> la foto aún no ha entrado en pantalla: la sección anterior va a su aire.
     sticky -> la foto está subiendo: la sección anterior queda clavada con su borde inferior en
               el borde inferior de la pantalla (la foto la tapa).
     follow -> la foto ya entró entera: la sección anterior se desplaza lo que mide la foto
               (translate fijo, sin cambiar) y se va con ella, sin salto en el relevo. */
if (!customElements.get('renovix-photo-cover')) {
  customElements.define('renovix-photo-cover', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.saved = null;
      this.key = '';
      this.scale = '';
      this.frame = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.wrapper = this.closest('.shopify-section') || this.parentElement;
      this.previous = this.wrapper.previousElementSibling;
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {this.frame=0;this.update();});
      };
      this.sync = () => this.update();
      const signal = this.abort.signal;
      window.addEventListener('scroll', this.sync, {passive:true,signal});
      window.addEventListener('resize', this.schedule, {passive:true,signal});
      this.reduced.addEventListener('change', this.schedule, {signal});
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this);
      if (this.previous) this.resize.observe(this.previous);
      this.schedule();
    }
    hold() {
      if (this.saved) return true;
      if (!this.previous) return false;
      const style = getComputedStyle(this.previous);
      if (style.translate !== 'none' && style.translate !== '0px') return false;
      this.saved = {};
      ['translate','position','top','z-index','will-change'].forEach(name => {
        this.saved[name] = {value:this.previous.style.getPropertyValue(name),priority:this.previous.style.getPropertyPriority(name)};
      });
      this.base = style.position;
      return true;
    }
    restore() {
      this.key = '';
      if (!this.saved || !this.previous) return;
      Object.entries(this.saved).forEach(([name,entry])=>{
        if(entry.value) this.previous.style.setProperty(name,entry.value,entry.priority);
        else this.previous.style.removeProperty(name);
      });
      this.saved=null;
    }
    apply(mode, cover, viewport) {
      const previous = this.previous;
      const height = previous ? previous.offsetHeight : 0;
      const key = mode + '|' + cover + '|' + viewport + '|' + height;
      if (key === this.key) return;
      if (mode === 'none' || !this.hold()) { this.restore(); return; }
      this.key = key;
      const style = previous.style;
      style.setProperty('z-index','1');
      if (mode === 'sticky') {
        style.setProperty('position','sticky');
        style.setProperty('top',(viewport - height) + 'px');
        style.removeProperty('translate');
      } else {
        style.setProperty('position', this.base === 'static' ? 'relative' : this.base);
        style.removeProperty('top');
        style.setProperty('translate','0 ' + cover + 'px');
      }
    }
    update() {
      const rect=this.getBoundingClientRect();
      const viewport=document.documentElement.clientHeight;
      const cover=Math.round(Math.min(viewport,rect.height));
      const enabled=this.dataset.pin==='true' && this.dataset.editor!=='true' && !this.reduced.matches;
      let mode='none';
      if(enabled && rect.top<viewport) mode = rect.top>viewport-cover ? 'sticky' : 'follow';
      this.apply(mode,cover,viewport);
      const amount=this.reduced.matches?0:Number(this.dataset.zoom||0)/100;
      const scale=amount>0 ? String(1+amount*(1-Math.max(0,Math.min(1,(viewport-rect.top)/Math.max(viewport,1))))) : '1';
      if(scale!==this.scale){this.scale=scale;this.style.setProperty('--rpc-scale',scale);}
    }
    disconnectedCallback() {
      this.abort?.abort();this.abort=null;
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);this.frame=0;
      this.restore();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renovix-hall-of-fame"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('renovix-hall-of-fame')) {
  customElements.define('renovix-hall-of-fame', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort=new AbortController();
      const signal=this.abort.signal;
      this.grid=this.querySelector('.rhf__grid');
      this.items=Array.from(this.querySelectorAll('.rhf__item'));
      this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
      this.pointer=matchMedia('(hover:hover) and (pointer:fine)');
      this.visible=true;this.frame=0;this.needsMeasure=true;
      this.schedule=(measure=false)=> {
        if(measure===true)this.needsMeasure=true;
        if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;if(!this.isConnected)return;if(this.needsMeasure){this.measure();this.needsMeasure=false;}this.update();});
      };
      this.items.forEach(item=>{
        const activate=()=>{if(this.dataset.hover==='true')item.classList.add('is-active');};
        const deactivate=()=>{if(!item.classList.contains('is-pinned')&&!item.contains(document.activeElement))item.classList.remove('is-active');};
        item.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&this.pointer.matches)activate();},{signal});
        item.addEventListener('pointerleave',deactivate,{signal});
        item.addEventListener('focusin',activate,{signal});
        item.addEventListener('focusout',e=>{if(!item.contains(e.relatedTarget)&&!item.classList.contains('is-pinned'))item.classList.remove('is-active');},{signal});
        item.addEventListener('click',e=>{
          if(this.dataset.hover!=='true'||!item.classList.contains('rhf__item--alternate')||this.pointer.matches||item.classList.contains('is-auto'))return;
          if(item.classList.contains('is-pinned'))return;
          e.preventDefault();
          this.items.forEach(other=>other.classList.remove('is-pinned','is-active'));
          item.classList.add('is-pinned','is-active');
        },{signal});
      });
      this.addEventListener('keydown',e=>{
        if(e.key==='Escape')this.items.forEach(item=>item.classList.remove('is-active','is-pinned'));
      },{signal});
      document.addEventListener('click',e=>{
        if(!e.target.closest('.rhf__item'))this.items.forEach(item=>item.classList.remove('is-active','is-pinned'));
      },{signal});
      document.addEventListener('shopify:block:select',e=>{
        const item=this.items.find(i=>i.dataset.blockId===e.detail.blockId);
        if(item){item.classList.add('is-editor-selected');item.scrollIntoView({behavior:'auto',block:'center'});}
      },{signal});
      document.addEventListener('shopify:block:deselect',e=>{this.items.find(i=>i.dataset.blockId===e.detail.blockId)?.classList.remove('is-editor-selected');},{signal});
      window.addEventListener('scroll',()=>{if(this.visible&&this.dataset.scroll==='true')this.schedule();},{passive:true,signal});
      window.addEventListener('resize',()=>this.schedule(true),{passive:true,signal});
      this.reduced.addEventListener('change',()=>this.schedule(),{signal});
      this.resize=new ResizeObserver(()=>this.schedule(true));
      this.resize.observe(this.grid);
      this.items.forEach(i=>this.resize.observe(i.querySelector('.rhf__label')));
      this.observer=new IntersectionObserver(entries=>{this.visible=entries.some(e=>e.isIntersecting);if(this.visible)this.schedule();},{rootMargin:'200px'});
      this.observer.observe(this);
      document.fonts?.ready.then(()=>{if(this.isConnected)this.schedule(true);});
      this.schedule(true);
      this.motion(signal);
      this.dataset.ready='';
    }
    motion(signal) {
      document.addEventListener('touchstart',()=>{},{passive:true,signal});
      const reduced=this.reduced;
      const hasIO='IntersectionObserver' in window;

      /* Batería: cada tarjeta se llena cuando entra en pantalla, de izquierda a derecha. */
      const bats=this.items.map(i=>({item:i,num:i.querySelector('.rhf__num'),fill:i.querySelector('.rhf__bat-fill')})).filter(b=>b.num&&b.fill);
      const setBat=(b,k)=>{const to=Number(b.num.dataset.to)||0;b.num.textContent=Math.round(to*k);b.fill.setAttribute('width',(to*.145*k).toFixed(2));};
      if(this.dataset.battery==='true'&&bats.length&&hasIO&&!reduced.matches){
        bats.forEach(b=>setBat(b,0));
        const io=new IntersectionObserver(entries=>{
          const fresh=entries.filter(e=>e.isIntersecting).map(e=>bats.find(b=>b.item===e.target)).filter(Boolean);
          fresh.forEach((b,n)=>{
            io.unobserve(b.item);
            const delay=n*110;let t0=null,end=false;
            const finish=()=>{if(!end){end=true;setBat(b,1);}};
            const step=t=>{
              if(end||!this.isConnected)return;
              if(t0===null)t0=t;
              const k=Math.min(1,Math.max(0,(t-t0-delay)/1100));
              setBat(b,1-Math.pow(1-k,3));
              if(k<1)requestAnimationFrame(step);else finish();
            };
            requestAnimationFrame(step);
            const guard=setTimeout(finish,delay+1700);
            signal.addEventListener('abort',()=>clearTimeout(guard));
          });
        },{threshold:.5});
        bats.forEach(b=>io.observe(b.item));
        signal.addEventListener('abort',()=>io.disconnect());
      }

      /* Cambio de color: al llegar a la sección (a los 0,25 s), una tarjeta visible cada vez y en orden.
         Una vuelta por defecto; se retoma si aparecen tarjetas nuevas o si sales y vuelves a entrar. */
      const alts=this.items.filter(i=>i.classList.contains('rhf__item--alternate'));
      if(this.dataset.auto==='true'&&alts.length&&hasIO&&!reduced.matches){
        const interval=Math.max(800,Number(this.dataset.autoTime)||2000);
        const loop=this.dataset.autoRepeat==='loop';
        const done=new Set();
        let timer=0,off=0,cur=null,hoverGrid=false,holdUntil=0,inView=false;
        const clear=()=>{clearTimeout(off);off=0;if(cur){cur.classList.remove('is-auto');cur=null;}};
        const seen=item=>{
          const r=item.getBoundingClientRect();
          const vh=window.innerHeight||document.documentElement.clientHeight;
          const vw=window.innerWidth||document.documentElement.clientWidth;
          if(!r.height||r.right<=0||r.left>=vw)return false;
          return (Math.min(r.bottom,vh)-Math.max(r.top,0))/r.height>=.7;
        };
        const busy=()=>hoverGrid||document.hidden||Date.now()<holdUntil||this.items.some(i=>i.classList.contains('is-active')||i.classList.contains('is-pinned'));
        const step=()=>{
          timer=0;
          if(!inView)return;
          if(!busy()){
            clear();
            let next=alts.find(i=>!done.has(i)&&seen(i));
            if(!next&&loop&&alts.some(seen)){done.clear();next=alts.find(seen);}
            if(next){done.add(next);cur=next;next.classList.add('is-auto');off=setTimeout(clear,Math.min(1800,Math.max(600,interval-200)));}
          }
          timer=setTimeout(step,interval);
        };
        const stop=()=>{clearTimeout(timer);timer=0;clear();};
        this.grid.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')hoverGrid=true;},{signal});
        this.grid.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse')hoverGrid=false;},{signal});
        this.grid.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse')holdUntil=Date.now()+5000;},{signal});
        const io=new IntersectionObserver(entries=>{
          entries.forEach(e=>{
            if(e.isIntersecting&&!inView){inView=true;done.clear();if(!timer)timer=setTimeout(step,250);}
            else if(!e.isIntersecting&&inView){inView=false;stop();}
          });
        });
        io.observe(this.grid);
        signal.addEventListener('abort',()=>{io.disconnect();stop();});
      }
    }
    path(width,height,labelWidth,labelHeight,normalized=false) {
      const x=v=>normalized?(v/width).toFixed(6):v.toFixed(3);
      const y=v=>normalized?(v/height).toFixed(6):v.toFixed(3);
      const inset=Math.max(.5,parseFloat(getComputedStyle(this).getPropertyValue('--rhf-border-width'))/2||.5);
      const left=inset,top=inset,right=width-inset,bottom=height-inset;
      const r=Math.min(Number(this.dataset.radius)||0,width*.12,height*.12);
      const notch=this.dataset.shape==='notched';
      const depth=notch?Math.min(height*.32,Math.max(height*(Number(this.dataset.notchHeight)||9)/100,labelHeight+8)):0;
      const label=notch?Math.min(width*(window.innerWidth<=749?.97:.96),Math.max(width*(Number(this.dataset.notch)||35)/100,labelWidth+12)):0;
      const nx=Math.max(r+depth*.5,right-label);
      const ny=bottom-depth;
      const slope=Math.min(depth*1.25,nx-left-r*2);
      if(!notch)return `M${x(left+r)} ${y(top)}H${x(right-r)}Q${x(right)} ${y(top)} ${x(right)} ${y(top+r)}V${y(bottom-r)}Q${x(right)} ${y(bottom)} ${x(right-r)} ${y(bottom)}H${x(left+r)}Q${x(left)} ${y(bottom)} ${x(left)} ${y(bottom-r)}V${y(top+r)}Q${x(left)} ${y(top)} ${x(left+r)} ${y(top)}Z`;
      const curve=Math.min(r,depth*.25);
      return `M${x(left+r)} ${y(top)}H${x(right-r)}Q${x(right)} ${y(top)} ${x(right)} ${y(top+r)}V${y(ny-r)}Q${x(right)} ${y(ny)} ${x(right-r)} ${y(ny)}H${x(nx+curve)}Q${x(nx)} ${y(ny)} ${x(nx-curve)} ${y(ny+curve)}L${x(nx-slope+curve)} ${y(bottom-curve)}Q${x(nx-slope)} ${y(bottom)} ${x(nx-slope-curve)} ${y(bottom)}H${x(left+r)}Q${x(left)} ${y(bottom)} ${x(left)} ${y(bottom-r)}V${y(top+r)}Q${x(left)} ${y(top)} ${x(left+r)} ${y(top)}Z`;
    }
    measure() {
      const gridStyle=getComputedStyle(this.grid);
      const columns=gridStyle.gridTemplateColumns.split(' ').filter(Boolean).length||4;
      const stagger=parseFloat(getComputedStyle(this).getPropertyValue(window.innerWidth<=749?'--rhf-stagger-mobile':'--rhf-stagger'))||0;
      this.items.forEach((item,index)=>{
        item.style.setProperty('--rhf-offset',(index%columns%2?stagger:0)+'px');
        const card=item.querySelector('.rhf__card'),label=item.querySelector('.rhf__label');
        const width=card.clientWidth,height=card.clientHeight;
        if(!width||!height)return;
        label.classList.remove('rhf__label--stack');
        const nameEl=label.querySelector('.rhf__name'),tagEl=label.querySelector('.rhf__tag');
        if(nameEl&&tagEl){
          const gap=parseFloat(getComputedStyle(label).columnGap)||0;
          if(nameEl.scrollWidth+tagEl.offsetWidth+gap+12>width*.88)label.classList.add('rhf__label--stack');
        }
        const labelWidth=label.offsetWidth,labelHeight=label.offsetHeight;
        const safe=this.dataset.shape==='notched'?Math.min(height*.32,Math.max(height*(Number(this.dataset.notchHeight)||9)/100,labelHeight+8)):0;
        item.style.setProperty('--rhf-safe-bottom',safe.toFixed(1)+'px');
        const d=this.path(width,height,labelWidth,labelHeight);
        item.querySelectorAll('.rhf__shape,.rhf__outline').forEach(svg=>svg.setAttribute('viewBox',`0 0 ${width} ${height}`));
        item.querySelectorAll('[data-frame-path]').forEach(path=>path.setAttribute('d',d));
        item.querySelector('[data-clip-path]').setAttribute('d',this.path(width,height,labelWidth,labelHeight,true));
        label.classList.toggle('rhf__label--inside',this.dataset.shape!=='notched');
      });
    }
    update() {
      if(this.reduced.matches){this.grid.style.setProperty('--rhf-factor','0');return;}
      if(this.dataset.scroll!=='true'){this.grid.style.setProperty('--rhf-factor','1');return;}
      const rect=this.grid.getBoundingClientRect(),height=document.documentElement.clientHeight;
      const progress=Math.max(0,Math.min(1,(height-rect.top)/(height+rect.height)));
      this.grid.style.setProperty('--rhf-factor',(1-progress).toFixed(4));
    }
    disconnectedCallback() {
      this.abort?.abort();this.abort=null;
      this.resize?.disconnect();this.observer?.disconnect();
      cancelAnimationFrame(this.frame);this.frame=0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renovix-quienessomos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('renovix-quienes')) {
  customElements.define('renovix-quienes', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const items = this.querySelectorAll('[data-fade-item]');
      const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.fade !== 'true' || this.dataset.editor === 'true' || calm || !('IntersectionObserver' in window)) return;
      this.classList.add('is-ready');
      this.io = new IntersectionObserver(es => es.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); this.io.unobserve(e.target); }
      }), { threshold: 0.07, rootMargin: '0px 0px -20px 0px' });
      items.forEach(el => this.io.observe(el));
    }
    disconnectedCallback() { this.io?.disconnect(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renovix-social-fan"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('renovix-social-fan')) {
  customElements.define('renovix-social-fan', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.stage = this.querySelector('.rsf__stage');
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      if (!this.stage || !this.cards.length) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.center = Math.floor(this.cards.length / 2);
      this.active = null;
      this.animated = this.dataset.animate === 'true' && !this.reduced.matches && !(window.Shopify && window.Shopify.designMode);
      this.prog = this.animated ? 0 : 1;
      this.target = this.prog;
      this.locked = !this.animated;
      this.raf = 0;
      this.measure();
      this.dataset.ready = '';
      if (this.animated) this.readScroll(true);
      this.layout(false);
      this.titleEl = this.querySelector('.rsf__heading');
      if (this.animated && this.titleEl) {
        this.setAttribute('data-title-hidden', '');
        this.titleScroll = () => {
          const r = this.titleEl.getBoundingClientRect();
          if (r.top < window.innerHeight * .78 && r.bottom > 0) this.showTitle();
        };
        window.addEventListener('scroll', this.titleScroll, {passive: true});
        window.addEventListener('resize', this.titleScroll, {passive: true});
        requestAnimationFrame(this.titleScroll);
      }
      this.cards.forEach((card, i) => {
        card.addEventListener('pointerenter', e => {
          if (e.pointerType === 'mouse' && this.prog >= .98) this.select(i);
        }, {signal});
        card.querySelector('button').addEventListener('click', () => { this.reveal(); this.select(i); }, {signal});
        card.addEventListener('focusin', () => { this.reveal(); this.select(i); }, {signal});
      });
      this.stage.addEventListener('pointerleave', e => {
        if (e.pointerType === 'mouse' && !this.stage.contains(document.activeElement)) this.select(null);
      }, {signal});
      this.stage.addEventListener('focusout', e => {
        if (!this.stage.contains(e.relatedTarget)) this.select(null);
      }, {signal});
      this.addEventListener('keydown', e => {
        if (e.key === 'Escape') { this.select(null); return; }
        if (!this.stage.contains(e.target) || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault();
        let next = this.active === null ? this.center : this.active;
        if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = this.cards.length - 1;
        else next = (next + (e.key === 'ArrowRight' ? 1 : -1) + this.cards.length) % this.cards.length;
        this.cards[next].querySelector('button').focus({preventScroll:true});
      }, {signal});
      this.querySelector('[data-prev]').addEventListener('click', () => this.step(-1), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.step(1), {signal});
      this.stage.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') this.touch = {x:e.clientX,y:e.clientY}; }, {signal,passive:true});
      this.stage.addEventListener('pointerup', e => {
        if (!this.touch) return;
        const dx = e.clientX-this.touch.x, dy = e.clientY-this.touch.y;
        this.touch = null;
        if (Math.abs(dx)>35 && Math.abs(dx)>Math.abs(dy)*1.3) { this.swiped = true; this.step(dx<0?1:-1); }
      }, {signal,passive:true});
      this.stage.addEventListener('pointercancel', () => {this.touch=null;}, {signal});
      this.stage.addEventListener('click', e => {
        if (this.swiped) {e.preventDefault();e.stopImmediatePropagation();this.swiped=false;}
      }, {signal,capture:true});
      this.resize = new ResizeObserver(() => {this.measure();this.layout(false);});
      this.resize.observe(this.stage);
      this.reduced.addEventListener('change', () => {if(this.reduced.matches){this.showTitle();this.reveal();}}, {signal});
      document.addEventListener('shopify:block:select', e => {
        const i = this.cards.findIndex(c=>c.dataset.blockId===e.detail.blockId);
        if (i>=0) {this.reveal();this.select(i);}
      }, {signal});
      if (this.animated) {
        const onScroll = () => { if (this.locked) return; this.readScroll(false); this.run(); };
        window.addEventListener('scroll', onScroll, {passive:true, signal});
        window.addEventListener('resize', onScroll, {passive:true, signal});
      }
    }
    measure() {
      this.mobile = window.innerWidth<=991;
      this.unit = this.stage.clientWidth/(this.mobile?48:84);
      this.cardWidth = this.unit*(this.mobile?14:20);
      this.stage.style.height = (this.unit*(this.mobile?36:44))+'px';
      this.cards.forEach(c=>c.style.width=this.cardWidth+'px');
    }
    base(i) {
      const middle = (this.cards.length-1)/2;
      const d = this.cards.length===1?0:(i-middle)/Math.max(middle,1)*3;
      const a = Math.abs(d), low = Math.floor(a), t=a-low;
      const xs = this.mobile?[0,6,11,15]:[0,11,22,30];
      const ys = [0,1.3,4,7.3], ss=[1,.9346,.8498,.7756];
      const mix = list=>list[low]+((list[Math.min(3,low+1)]??list[low])-list[low])*t;
      return {x:Math.sign(d)*mix(xs), y:mix(ys), s:mix(ss), r:d*7, z:10-Math.round(a)*2};
    }
    transform(p) {
      return `translate(calc(-50% + ${p.x*this.unit}px), ${p.y*this.unit}px) rotate(${p.r}deg) scale(${p.s})`;
    }
    readScroll(snap) {
      const r = this.stage.getBoundingClientRect(), vh = window.innerHeight;
      const start = vh * .92, end = vh * .4;
      this.target = Math.max(0, Math.min(1, (start - r.top) / (start - end)));
      if (snap) this.prog = this.target;
    }
    run() {
      if (this.raf) return;
      const step = () => {
        const d = this.target - this.prog;
        if (Math.abs(d) < .002) { this.prog = this.target; this.layout(false); this.raf = 0; return; }
        this.prog += d * .14;
        this.layout(false);
        this.raf = requestAnimationFrame(step);
      };
      this.raf = requestAnimationFrame(step);
    }
    layout(transition=true) {
      const n = this.cards.length, mid = (n-1)/2, full = this.prog >= .999;
      const ease = t => 1 - Math.pow(1 - t, 3);
      this.cards.forEach((card,i)=> {
        const o = this.base(i), selected = full && i===this.active;
        const dist = Math.abs(i-mid)/Math.max(mid,1);
        const q = ease(Math.max(0, Math.min(1, (this.prog - dist*.25)/.75)));
        const c = {x:0, y:10+(n-1-i)*.8, r:0, s:1};
        const p = {x:c.x+(o.x-c.x)*q, y:c.y+(o.y-c.y)*q, r:c.r+(o.r-c.r)*q, s:c.s+(o.s-c.s)*q, z:o.z};
        if (full && this.active!==null) {
          const delta=i-this.active, distance=Math.abs(delta);
          if (selected) {p.y-=2.5;p.s*=1.08;p.z=30;}
          else {
            const central=1-Math.abs((i-(n-1)/2)/Math.max((n-1)/2,1));
            p.x+=Math.sign(delta)*(this.mobile?1:8)*central*(1+.2*Math.max(0,3-distance));
            p.r+=Math.sign(delta)*3/(distance+1);
          }
        }
        card.style.transition=transition?'':'none';
        card.style.transform=this.transform(p);
        card.style.zIndex=p.z;
        card.classList.toggle('is-active',selected);
        card.querySelector('button').setAttribute('aria-pressed',String(selected));
        const link=card.querySelector('a');
        if(link) link.tabIndex=selected?0:-1;
      });
      const counter=this.querySelector('.rsf__counter');
      if(counter) counter.textContent=`${(this.active===null?this.center:this.active)+1} / ${this.cards.length}`;
    }
    reveal() {
      this.showTitle();
      this.locked = true;
      if (this.raf) {cancelAnimationFrame(this.raf);this.raf=0;}
      this.prog = 1;
      this.target = 1;
      this.layout(false);
    }
    showTitle() {
      if(this.titleScroll) {
        window.removeEventListener('scroll',this.titleScroll);
        window.removeEventListener('resize',this.titleScroll);
        this.titleScroll=null;
      }
      this.removeAttribute('data-title-hidden');
    }
    select(index) {this.active=index;this.layout();}
    step(direction) {this.reveal();this.select(((this.active??this.center)+direction+this.cards.length)%this.cards.length);}
    disconnectedCallback() {
      this.controller?.abort();this.controller=null;
      this.showTitle();
      if (this.raf) {cancelAnimationFrame(this.raf);this.raf=0;}
      this.resize?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
